import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "FojaConceptoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "FojaConceptoPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexFojaConcepto(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Persona', name: 'Persona', title: 'Persona' },
                { data: 'FojaConcepto', name: 'FojaConcepto', title: 'FojaConcepto' },
                { data: 'Glosa', name: 'Glosa', title: 'Glosa' },
                { data: 'Estado', name: 'Estado', title: 'Estado' },
                { data: 'CalificadoPor', name: 'CalificadoPor', title: 'Calificado Por' },
                { data: 'Fecha', name: 'Fecha', title: 'Fecha' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                { data: 'EstadoDocumento', name: 'EstadoDocumento', title: 'Estado Documento' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            fojaconceptos: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            password: {},
            fojaconcepto: {},
            
        };
    },
    methods: {
        loadFile(input) {
            this.isLoadingFile = true;
            input = event.target;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                var data = new FormData();
                data.append('File', input.files[0]);
                this.ss.uploadFile(data)
                    .then(result => {
                        if (result.data.success) {
                            this.$bvToast.toast(
                                result.data.msg,
                                {
                                    title: 'Correcto',
                                    variant: 'info',
                                    autoHideDelay: 5000
                                }
                            )
                            this.fojaconcepto.Archivo = result.data.data;
                        } else {
                            this.$bvToast.toast(
                                result.data.msg,
                                {
                                    title: 'Oops!',
                                    variant: 'danger',
                                    autoHideDelay: 5000
                                }
                            )
                        }
                        this.isLoadingFile = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.$bvToast.toast(
                            'Error subiendo archivo',
                            {
                                title: 'Oops!',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                        this.isLoadingFile = false;
                    });
            }
        },
        
        newFojaConcepto() {
            this.fojaconcepto = {};
            this.$refs['frm-fojaconcepto'].show();
            // console.log("hhhhola")
        },
        showFojaConcepto(id) {
            this.isLoading=true;
            this.ss.showFojaConcepto(id).then(
                (result) => {
                    let response = result.data;
                    this.fojaconcepto = response.data;
                    this.$refs['view-fojaconcepto'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editFojaConcepto() {
            this.$refs['frm-fojaconcepto'].show();
            this.$refs['view-fojaconcepto'].hide();
        },
        cancelFojaConcepto() {
            if (this.fojaconcepto.id) {
                this.$refs['view-fojaconcepto'].show();
            }
            this.$refs['frm-fojaconcepto'].hide();
        },
        saveFojaConcepto() {
            this.ss.storeFojaConcepto(this.fojaconcepto).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-fojaconcepto'].hide();
                    this.$refs['datatable-fojaconcepto'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteFojaConcepto() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyFojaConcepto(this.fojaconcepto)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-fojaconcepto'].hide();
                                this.$refs['datatable-fojaconcepto'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-fojaconcepto'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-fojaconcepto'].show();
        },
        changePassword() {
            this.password.FojaConcepto = this.fojaconcepto.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-fojaconcepto'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-FojaConcepto').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showFojaConcepto(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
